import * as z from "zod"
import { ProviderDataMapType, DataType } from "@prisma/client"

export const ProviderDataMapModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string(),
  type: z.nativeEnum(ProviderDataMapType),
  checkValue: z.string(),
  checkValueType: z.nativeEnum(DataType),
  resultValue: z.string(),
  resultValueType: z.nativeEnum(DataType),
})
